module.exports = __webpack_public_path__ + "static/img/slsPurpose2.4d21a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsPurpose2.png
// module id = xePU
// module chunks = 2